// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';

export const SocialitePanel = styled.div`
  padding-top: 10px;
  
  a {
    display: flex; 
    align-items: center;
    
    img {
        height: 35px;
        padding-right: 10px;
    }
  }
`;
